/** @jsxImportSource @emotion/react */
import {
  BlueLine,
  colors,
  Container,
  Divider,
  HeadingH1,
  HeadingH3,
  Section,
} from 'components/landing/ui';
import React from 'react';

import bg1x from '../../images/s1-bg-1x.png';
import bg2x from '../../images/s1-bg-2x.png';
import bg3x from '../../images/s1-bg-3x.png';
import TryForFree from './try-for-free';

const S1 = React.forwardRef(({ openVideo }, ref) => (
  <Container ref={ref}>
    <Section css={{ paddingTop: 30 }}>
      <div
        css={{
          '>div:nth-of-type(1)': {
            flexBasis: '50%',
            flexShrink: 1,
            flexDirection: 'column',
            order: 2,
            alignItems: 'center',
            textAlign: 'center',

            '@media (min-width:992px)': {
              order: 1,
              alignItems: 'flex-start',
              textAlign: 'left',
              marginRight: 30,
            },
            '@media (min-width:1366px)': { marginRight: 0 },
          },
          '>div:nth-of-type(2)': {
            flexBasis: '50%',
            flexShrink: 1,
            alignItems: 'center',
            justifyContent: 'center',
            order: 1,
            '@media (min-width:992px)': { order: 2, justifyContent: 'flex-start' },
          },

          '@media (min-width:992px)': { flexDirection: 'row', paddingBottom: 100 },
          '@media (min-width:1366px)': { paddingBottom: 120 },
          flexDirection: 'column',
          alignItems: 'stretch',
          paddingBottom: 50,
        }}
      >
        <div>
          <HeadingH1 css={{ marginBottom: 30, '@media (min-width:992px)': { maxWidth: 460 } }}>
            Приведем и <span css={{ color: colors.blue }}>удержим</span> клиентОВ для вашего бизнеса
          </HeadingH1>

          <BlueLine css={{ marginBottom: 20 }} />

          <HeadingH3
            css={{
              color: colors.grayLight,
              marginBottom: 30,
              '@media (min-width:768px)': { marginBottom: 50 },
            }}
          >
            Сервис №1{' '}
            <br
              css={{
                '@media (min-width:992px)': {
                  display: 'block',
                },
                display: 'none',
              }}
            />
            по автоматизации личной страницы во Вконтакте
          </HeadingH3>

          <TryForFree openVideo={openVideo} />
        </div>
        <div css={{ paddingLeft: 0, '@media (min-width:1366px)': { paddingLeft: 40 } }}>
          <img
            srcSet={`${bg1x} 1x, ${bg2x} 2x, ${bg3x} 3x`}
            css={{ width: '100%', maxWidth: 506 }}
          />
        </div>
      </div>
      <Divider />
    </Section>
  </Container>
));

export default S1;
